/**
 * HatchEgg using createContext and no top-level menu.
 * The page state is provided via PageContext so child components
 * can read or change the active page as needed.
 */

import React, { useState } from 'react';
import MainPage from './main/MainPage';
import PlayPage from './play/PlayPage';
import ColloectionPage from './collection/ColloectionPage';
import { HATCH_EGG_PAGE } from '../../actions/hatch-egg';
import { useSelector } from 'react-redux';

const HatchEgg = ({ history }) => {
  const hatchEgg = useSelector((state) => state.hatchEgg);
  const renderPage = () => {
    switch (hatchEgg.page) {
      case HATCH_EGG_PAGE.PLAY:
        return <PlayPage />;
      case HATCH_EGG_PAGE.COLLOECTION:
        return <ColloectionPage />;
      default:
        return <MainPage history={history} />;
    }
  };

  return <>{renderPage()}</>;
};

export default HatchEgg;
